import mainTemplate from './views/base.tpl.html';
import listTemplate from './views/list.tpl.html';
import detailsTemplate from './views/details.tpl.html';

angular
    .module('festzelt-os.shippings')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.shippings', {
            abstract: true,
            url: '/shippings',
            templateUrl: mainTemplate,
            params:{
                back: 'app.shippings.index',
                backParams: ['$stateParams', ($stateParams) => {
                    return {
                        store: $stateParams.store,
                    }
                }],
            },
            data: {
                showBackBtn: true,
                pageTitle: 'Shippings'
            }
        })
        .state('app.shippings.index', {
            url: '',
            sticky: true,
            data: {
                showBackBtn: false,
                rights: 'shipping::list',
                view: 'list'
            },
            views: {
                list: {
                    templateUrl: listTemplate,
                    controller: 'ShippingsListCtrl',
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.shippings.details', {
            url: '/{sid}',
            params: {
                shipping: undefined,
                store: undefined
            },
            sticky: true,
            data: {
                view: 'details',
                rights: 'shipping::edit'
            },
            views: {
                'details': {
                    templateUrl: detailsTemplate,
                    controller: 'ShippingDetailsCtrl',
                    controllerAs: 'vm'
                }
            }
        } );
}



// WEBPACK FOOTER //
// ./src/app/pages/shippings/shippings-routes.js